import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import './AlertRulesConfig.css';
import '../../../cssfiles/homepage.css';
import AssetTagsRetrieval from './AssetTagsRetrieval';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { getdevicetags1, postalarmconfig, getNotifcationUserGroups,postNotification } from '../../../Restclient/datacollection';
import CustomCancelButton from '../../CommonComponents/CustomCancelButton';
import CustomTableHeading from '../../CommonComponents/CustomTableHeading';
import CustomActionButton from '../../CommonComponents/CustomActionButton';
import CustomDialogBox from '../../CommonComponents/CustomDialogBox';

import Chip from '@mui/material/Chip';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    
  } from '@mui/material';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useSelector } from "react-redux";
import LK_Delete from '../../../images/LK_Delete';
import { validate } from 'uuid';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import { Checkbox} from '@mui/material';

const renderTreeNodes = (node,checkedNode, devicename, deviceId) => {

  if(node.hasOwnProperty("Userid") && node.hasOwnProperty("UserName")){
      return (
          <TreeItem
              key={deviceId + node["Userid"]}
              itemId={deviceId + node["Userid"]}
              label={
                  <Typography sx={{ display: 'flex', alignItems: 'left',whiteSpace: "nowrap",overflow: "hidden",textOverflow: "ellipsis" }}>
                      <span style={{color:'var(--SecondaryText)'}}>{node["UserName"]}</span>
                  </Typography>
              }
              sx={{'& .MuiTreeItem-label':{
                            fontSize:'16px',
                            fontWeight:400,
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden'
                        },}}
          >
          </TreeItem>
      );
  }
 
};

export default function AlertRulesConfig(props){
    function handleCancelChange(){
        props.setAlarmRules(false)
    }
    const [checkedNode, setCheckedNode] = useState(null); //z Holds the id of the currently checked node
    const [checkedNodes, setCheckedNodes] = useState([]);
    const [enableAlert, setenableAlert] = useState(false);
    const [sendMessage, setsendMessage] = useState(false);
    const [sendEmail, setsendEmail] = useState(false);
    const [enablehighestprioritynotification, setenablehighestprioritynotification] = useState(false);
    const [enablehighprioritynotification, setenablehighprioritynotification] = useState(false);
    const [enablemediumprioritynotification, setenablemediumprioritynotification] = useState(false);
    const [enablelowprioritynotification, setenablelowprioritynotification] = useState(false);
    const userdetails = useSelector((state) => state.logindata.userdetails)
    const [existingDeviceTagAlarmConfig, setExistingDeviceTagAlarmConfig] = useState(false);
    const [selectedTag, setSelectedTag] = useState({ tagid:'',tagname: '', tagunit: '', std_tagname: '', tagdatatype:'',projectid:''});
    const [selectedAsset, setSelectedAsset] = useState({asset_name:'', device_id:''});
    const themechange = useSelector((state) => state.themedata.theme)
    const overviewstate = useSelector((state) => state.mainpagedata.overviewbarstate)
    const tagdetailsobject = useSelector((state) => state.mainpagedata.tagdetailsobject);
    const [pagesize, setPagesize] = useState(370)
    const [configurationValidation, setConfigurationValidation] = useState({datavalidation:true, rangevalidation:true});
    const [boolallconditionsfilled, setboolAllConditionsfilled] = useState(true);
    const [alarmrulefilled, setAlarmRulefilled] = useState(true);
    const [confirmAlarmTagset, setConfirmAlarmTagset] = useState(true);
    const [assetdata,setAssetData] = useState(null);
    const [assetdataerror,setAssetDataError] = useState(false);
    const [userGroups, setUserGroups ] = useState([]);
    const [openAlertRuleNameExceedsLength, setopenAlertRuleNameExceedsLength] = useState(false);
    const [openAlertRuleSetpointandMessages, setopenAlertRuleSetpointandMessages] = useState(false);
    const [openAlertRuleMessages, setopenAlertRuleMessages] = useState(false);
    const [userGroupsError, setUserGroupsError] = useState(false);
    const selectedprojectname = useSelector((state) => state.mainpagedata.selectedprojectname)
    function handleAlertRuleMessages(){
        setopenAlertRuleMessages(false)
    }

    function handleAlertRuleNameExceedsLength(){
        setopenAlertRuleNameExceedsLength(false)
    }

    function handleAlertRuleSetpointandMessages(){
        setopenAlertRuleSetpointandMessages(false)
    }

    useEffect(() => {
        //// console.log("overviewstate ",overviewstate)
        if(overviewstate) {
            setPagesize(323)
        } else {
            setPagesize(288)
        }
    },[overviewstate])

    const getNotifcationUserGroupscallback = (res, status) => {
        if(status == 200){
            setUserGroups(res?.data)
            setUserGroupsError(false);
        }else{
            setUserGroups([])
            setUserGroupsError(true);
        }
        
    }

    useEffect(() => {
        if(selectedprojectname != undefined || selectedprojectname != null || selectedprojectname != ''){
            if(userdetails && userdetails.Projectid && userdetails.Projectlist){
                //getalarmgroups(alarmgroupscallback)
                getdevicetags1(selectedprojectname,userdetails.Projectlist, assetcallback)
                getNotifcationUserGroups(selectedprojectname,userdetails.Projectlist,getNotifcationUserGroupscallback)
                /* getalarmevents(alarmeventscallback)*/
            }
        }

        // if(userdetails.Projectid == 'All'){
        //     //getalarmgroups(alarmgroupscallback)
        //     getdevicetags1(selectedprojectname, assetcallback)
        //     getNotifcationUserGroups(selectedprojectname, getNotifcationUserGroupscallback)
        //     /* getalarmevents(alarmeventscallback)*/
        // }else{
        //     //getalarmgroups(alarmgroupscallback)
        //     getdevicetags1(userdetails.Projectid, assetcallback)
        //     getNotifcationUserGroups(userdetails.Projectid, getNotifcationUserGroupscallback)
        //     /* getalarmevents(alarmeventscallback)*/
        // }
        
        
    }, [selectedprojectname]);

    const handleCheck = (event, node, nodeId, devicename, deviceId) => {
    
        // Add or remove the selected node object based on its current state
        setCheckedNodes((prevCheckedNodes) => {
            const isNodeSelected = prevCheckedNodes.some(checkedNode => checkedNode?.id === nodeId);
    
            if (isNodeSelected) {
                // If the node is already checked, remove it from the array
                return prevCheckedNodes.filter(checkedNode => checkedNode?.id !== nodeId);
            } else {
                // If the node is not checked, add it to the array
                return [...prevCheckedNodes, { ...node }];
            }
        });
    };
    
    // const alarmgroupscallback = (res) => {
    //     //setData(res);
    // };

    const assetcallback = (res,status) => {
        // console.log("res obtd in assetscallback in AssetRulesConfig",res?.data)
        if(status == 200){
            setAssetData(res?.data);
            setAssetDataError(false);
        }else{
            setAssetData({"devices":[]})
            setAssetDataError(true);
        }
        
    };

    const alarmeventscallback = (res) => {
        // console.log("res obtd in alarmeventscallback",res.data)
    };

    const [numConditions, setNumConditions] = useState(1); // Default number of conditions
    const [showTable, setShowTable] = useState(false); // Whether to display the table
    const [conditions, setConditions] = useState([{ type: '',condition: '', setpoint1: '',setpoint2: '', alarmpriority:'',normalmessage:'', abnormalmessage:'' }]); // Store conditions entered by the user
    const [boolconditions, setBoolConditions] = useState([{ condition: 'TRUE', alarmpriority:'',normalmessage:'', abnormalmessage:'' },{ condition: 'FALSE', alarmpriority:'',normalmessage:'', abnormalmessage:'' }]); // Store conditions entered by the user
    const [conditionsequal, setConditionsEqual] = useState([{ condition: '=', setpoint: '', alarmpriority:'',normalmessage:'', abnormalmessage:'' }]); // Store conditions entered by the user
    const [conditionsranges, setConditionsRanges] = useState([{ lowersetpoint :'', condition: '', uppersetpoint: '', alarmpriority:'',normalmessage:'', abnormalmessage:'' }]);
    const [tempConditions, setTempConditions] = useState([]);
    const [conflictingConditionsGroups, setConflictingConditionsGroups] = useState([]);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [open, setOpen] = useState(false);
    const [objecttosavealarmrule, setObjecttosavealarmrule] = useState({});
    const [openAtLeastOneConditionDialog, setopenAtLeastOneConditionDialog] = useState(false);
    const [openMaxConditionDialog, setopenMaxConditionDialog] = useState(false);
    const [openAlarmUpdatedandSaved, setopenAlarmUpdatedandSaved] = useState(false);
    const [alertruleNotSaved, setalertruleNotSaved] = useState(false);
    const [openDuplicateAlarm, setopenDuplicateAlarm] = useState(false)
    const [openDuplicateAlarmMsg, setopenDuplicateAlarmMsg] = useState("")


    function handleaslertRuleNotSaved(){
        setalertruleNotSaved(false);
    }
    
    // Handle closing the dialog
    const handleClose = () => {
        setOpen(false);
    };

    // const handleConfirm = () => {
    //     // Ensure the conditions are reset before setting new conditions
    //     setConditions(tempConditions.map(cond => ({...cond})));
    //     setShowTable(true);
    //     setOpenConfirmDialog(false);
    // };
    
    const handleConditionChange = (index, field, value) => {
        var updatedConditions;

        if(selectedTag.tagdatatype === 'bool'){
            updatedConditions = conditions.map((condition, i) => 
                i === index ? { ...condition, [field]: value } : condition
            );  
            updatedConditions[index]['condition'] = "="
            updatedConditions[index]['setpoint1'] = (updatedConditions[index]['type'] == "True") ? "1" : (((updatedConditions[index]['type'] == "False")) ? "0" : "")
            updatedConditions[index]['setpoint2'] = ""
        }else{
            updatedConditions = conditions.map((condition, i) => 
                i === index ? { ...condition, [field]: value } : condition
            );
        }

        setConditions(updatedConditions);
    };   

    function handleConfirmationDuplicateAlarm(){
        setopenDuplicateAlarm(false);
    }

    function handleCloseDuplicateAlarm(){
        setopenDuplicateAlarm(false);
    }

    const handleConfirmationAtLeastOneConditionDialog = () => {
    
        setopenAtLeastOneConditionDialog(false)
    }

    const handleCloseAtLeastOneConditionDialog = () => {
    
        setopenAtLeastOneConditionDialog(false)
    }

    const handleConfirmationMaxConditionDialog = () => {
    
        setopenMaxConditionDialog(false)
    }

    const handleCloseMaxConditionDialog = () => {
    
        setopenMaxConditionDialog(false)
    }

    const handleAddRow = () => {
        if(conditions.length >= 11){
            setopenMaxConditionDialog(true)
            return;
        }else{
            setConditions([...conditions, { type: '', condition: '', setpoint1: '',setpoint2: '', alarmpriority:'',normalmessage:'', abnormalmessage:''}]);
        }
        
    };

    // Remove a condition row
    const handleRemoveRow = (index) => {
        if(conditions.length == 1 && index==0){
            setopenAtLeastOneConditionDialog(true)
            return;
        }

        const updatedConditions = conditions.filter((_, i) => i !== index);
        setConditions(updatedConditions);
    };
     
    const [alarmrulename, setAlarmRuleName] = useState('');
    // const postalarmconfigcallback = (res, status) => {
    //     if(status == 200){
    //         if (res && res.data && res.data.data && res.data.data.data) {
    //             console.log("res postalarmconfigcallback",res.data.data)
    //             if((res?.data?.data?.data?.msg == 'Alarm Rule with same name and for same device tag already exists') || (res?.data?.data?.data?.msg == 'Alarm Rule with same name already exists') || (res?.data?.data?.data?.msg == 'Alarm Rule for same device tag already exists')){
    //                 setopenDuplicateAlarm(true)
    //                 setopenDuplicateAlarmMsg(res?.data?.data?.data?.msg)
    //                 setalertruleNotSaved(false);
    //             }else if(res?.data?.data?.data?.msg == 'Does not exist'){
    //                 setopenAlarmUpdatedandSaved(true);
    //                 setalertruleNotSaved(false);
    //             }
    //         }else {
    //             console.error("Invalid response structure:", res);
    //             setalertruleNotSaved(true);
    //         }
           
    //     }else{
    //         setalertruleNotSaved(true);
    //     }
        
    // }
    const postalarmconfigcallback = (res, status) => {
        
        if (status === 200 || status === 201) {
            if (res && res.data && res.data.data) {
                const msg = res.data.data.msg || res.data.data.message;
                if (msg === 'Alarm Rule with same name and for same device tag already exists' ||
                    msg === 'Alarm Rule with same name already exists' ||
                    msg === 'Alarm Rule for same device tag already exists') {
                    setopenDuplicateAlarm(true);
                    setopenDuplicateAlarmMsg(msg);
                    setalertruleNotSaved(false);
                } else if (msg === 'Does not exist' || msg === 'Alert rule created successfully') {
                    setopenAlarmUpdatedandSaved(true);
                    setalertruleNotSaved(false);
                } else {
                    setalertruleNotSaved(true);
                }
            } else {
                setalertruleNotSaved(true);
            }
        } else if (status === 409) {
            // Conflict: duplicate
            setopenDuplicateAlarm(true);
            setopenDuplicateAlarmMsg(res.data.data.msg || res.data.data.message || 'Duplicate');
            setalertruleNotSaved(false);
        } else {
            setalertruleNotSaved(true);
            
        }
    }

    const doesOverlap = (range1, range2) => {
        const { lowerBound: l1, upperBound: u1, lowerCondition: lc1, upperCondition: uc1 } = range1;
        const { lowerBound: l2, upperBound: u2, lowerCondition: lc2, upperCondition: uc2 } = range2;
      
        //lower bound  and upper bound conditions comparison
        const lowerBound1Satisfies = lc1 === ">=" ? (Number(l1) <= Number(u2)) : (Number(l1) < Number(u2));
        const lowerBound2Satisfies = lc2 === ">=" ? (Number(l2) <= Number(u1)) : (Number(l2) < Number(u1));
      
        const upperBound1Satisfies = uc1 === "<=" ? (Number(u1) >= Number(l2)) : (Number(u1) > Number(l2));
        const upperBound2Satisfies = uc2 === "<=" ? (Number(u2) >= Number(l1)) : (Number(u2) > Number(l1));
      
        //console.log("lowerBound1Satisfies",lowerBound1Satisfies,"lowerBound2Satisfies",lowerBound2Satisfies,"upperBound1Satisfies",upperBound1Satisfies,"upperBound2Satisfies",upperBound2Satisfies,"range1",range1,"range2",range2)
        return lowerBound1Satisfies && upperBound1Satisfies && lowerBound2Satisfies && upperBound2Satisfies;
    };  
      
    // union find - Disjoint Set 
    const find = (parent, i) => {
        if (parent[i] === i) return i;
        return parent[i] = find(parent, parent[i]);
    };
    
    const union = (parent, rank, x, y) => {
        let rootX = find(parent, x);
        let rootY = find(parent, y);    

        if (rootX !== rootY) {
            if (rank[rootX] > rank[rootY]) {
                parent[rootY] = rootX;
            } else if (rank[rootX] < rank[rootY]) {
                parent[rootX] = rootY;
            } else {
                parent[rootY] = rootX;
                rank[rootX]++;
            }
        }
    };

    const findConflictingGroups = (conditionsparameter) => {
        //console.log("conditionsparameter-findConflictingGroups",conditionsparameter)
        const n = conditionsparameter.length;
        const parent = Array(n).fill().map((_, i) => i);
        const rank = Array(n).fill(0);
    
        // Compare each condition with every other condition
        for (let i = 0; i < n; i++) {
          for (let j = i + 1; j < n; j++) {
            if (doesOverlap(conditionsparameter[i], conditionsparameter[j])) {
              union(parent, rank, i, j);
            }
          }
        }
    
        // creating groups from the union-find structure
        const groups = {};
        for (let i = 0; i < n; i++) {
          const root = find(parent, i);
          if (!groups[root]) {
            groups[root] = [];
          }
          groups[root].push(conditionsparameter[i]);
        }
    
        return Object.values(groups);
    };
    
    function validateConditions(conditions){
        var validdata = true;
        var validrange = true;
        //console.log("selectedTag.tagdatatype",selectedTag.tagdatatype)
        switch(selectedTag.tagdatatype){
            case 'bool':
                
                for(var i=0;i<conditions.length;i++){
                    
                    if(conditions[i].type == ''){
                        //console.log("Hereinside-----validdata-----------recahed1",conditions[i].type)
                        validdata = false;
                    }
                    //console.log("Hereafter -----validdata-----------recahed1",validdata)

                    if(conditions[i].alarmpriority == ''){
                        //console.log("Hereinside-----validdata-----------recahed2",conditions[i].alarmpriority)
                        validdata = false;
                    }
                    //console.log("Hereafter -----validdata-----------recahed2",validdata)

                    if(conditions[i].condition == ''){
                        //console.log("Hereinside-----validdata-----------recahed3",conditions[i].condition)
                        validdata = false;
                    }
                    //console.log("Hereafter -----validdata-----------recahed3",validdata)

                    if(conditions[i].setpoint1 == ''){
                        if(conditions[i].setpoint1 == ''){
                            //console.log("THIS IS AN EMPTY STRING")
                        }else if(conditions[i].setpoint1 != ''){
                            //console.log("THIS IS NOT AN EMPTY STRING")
                        }
                        //console.log("Hereinside-----validdata-----------recahed4",conditions[i].setpoint1)
                        validdata = false;
                    }
                    //console.log("Hereafter -----validdata-----------recahed4",validdata)

                    // if((conditions[i].type == '') || (conditions[i].alarmpriority == '') || (conditions[i].condition == '') || (conditions[i].setpoint1 == '')){
                    //     console.log("conditions[i].type========",conditions[i].type)
                    //     console.log("conditions[i].alarmpriority========",conditions[i].alarmpriority)
                    //     console.log("conditions[i].condition========",conditions[i].condition)
                    //     console.log("conditions[i].setpoint1========",conditions[i].setpoint1)
                    //     validdata = false;
                    // }
                    
                    if((Number(conditions[i].setpoint1) != 0) && (Number(conditions[i].setpoint1) != 1)){
                        validrange = false;
                    }
                }
                
                break
            case 'int32':
                for(var i=0;i<conditions.length;i++){
                    if((conditions[i].type == '') || (conditions[i].alarmpriority == '') || (conditions[i].condition == '') || (conditions[i].setpoint1 == '')){
                        validdata = false;
                    }

                    if(conditions[i].type == 'Ranges'){
                        if(conditions[i].setpoint2 == ''){
                            validdata = false;
                        }

                        if((Number(conditions[i].setpoint2) < -2147483648) || (Number(conditions[i].setpoint2) > 2147483647)){
                            validrange = false;
                        }
                    }
                  
                    if((Number(conditions[i].setpoint1) < -2147483648) || (Number(conditions[i].setpoint1) > 2147483647)){
                        validrange = false;
                    }

                }
                break
            case 'uint32':
                for(var i=0;i<conditions.length;i++){
                    if((conditions[i].type == '') || (conditions[i].alarmpriority == '') || (conditions[i].condition == '') || (conditions[i].setpoint1 == '')){
                        validdata = false;
                    }

                    if(conditions[i].type == 'Ranges'){
                        if(conditions[i].setpoint2 == ''){
                            validdata = false;
                        }

                        if((Number(conditions[i].setpoint2) < 0) || (Number(conditions[i].setpoint2) > 4294967295)){
                            validrange = false;
                        }
                    }
                  
                    if((Number(conditions[i].setpoint1) < 0) || (Number(conditions[i].setpoint1) > 4294967295)){
                        validrange = false;
                    }

                }
                break
            case 'int64':
                for(var i=0;i<conditions.length;i++){
                    if((conditions[i].type == '') || (conditions[i].alarmpriority == '') || (conditions[i].condition == '') || (conditions[i].setpoint1 == '')){
                        validdata = false;
                    }

                    if(conditions[i].type == 'Ranges'){
                        if(conditions[i].setpoint2 == ''){
                            validdata = false;
                        }

                        if((Number(conditions[i].setpoint2) < -9223372036854775808) || (Number(conditions[i].setpoint2) > 9223372036854775807)){
                            validrange = false;
                        }
                    }
                  
                    if((Number(conditions[i].setpoint1) < -9223372036854775808) || (Number(conditions[i].setpoint1) > 9223372036854775807)){
                        validrange = false;
                    }

                }
                break
            case 'uint64':
                for(var i=0;i<conditions.length;i++){
                    if((conditions[i].type == '') || (conditions[i].alarmpriority == '') || (conditions[i].condition == '') || (conditions[i].setpoint1 == '')){
                        validdata = false;
                    }

                    if(conditions[i].type == 'Ranges'){
                        if(conditions[i].setpoint2 == ''){
                            validdata = false;
                        }

                        if((Number(conditions[i].setpoint2) < 0) || (Number(conditions[i].setpoint2) > 18446744073709551615)){
                            validrange = false;
                        }
                    }
                  
                    if((Number(conditions[i].setpoint1) < 0) || (Number(conditions[i].setpoint1) > 18446744073709551615)){
                        validrange = false;
                    }

                }
                break
            case 'float':
                for(var i=0;i<conditions.length;i++){
                    if((conditions[i].type == '') || (conditions[i].alarmpriority == '') || (conditions[i].condition == '') || (conditions[i].setpoint1 == '')){
                        validdata = false;
                    }

                    if(conditions[i].type == 'Ranges'){
                        if(conditions[i].setpoint2 == ''){
                            validdata = false;
                        }

                        if(!isFinite(Number(conditions[i].setpoint2))){
                            validrange = false;
                        }
                    }
                  
                    if(!isFinite(Number(conditions[i].setpoint1))){
                        validrange = false;
                    }

                }
                
                break
            case 'double':
                for(var i=0;i<conditions.length;i++){
                    if((conditions[i].type == '') || (conditions[i].alarmpriority == '') || (conditions[i].condition == '') || (conditions[i].setpoint1 == '')){
                        validdata = false;
                    }

                    if(conditions[i].type == 'Ranges'){
                        if(conditions[i].setpoint2 == ''){
                            validdata = false;
                        }

                        if(!isFinite(Number(conditions[i].setpoint2))){
                            validrange = false;
                        }
                    }
                  
                    if(!isFinite(Number(conditions[i].setpoint1))){
                        validrange = false;
                    }

                }
                break
        }

        setConfigurationValidation({datavalidation:validdata, rangevalidation:validrange})
    }

    function handleSaveChange(){
        var currentConditions = [];
        var conditionstoSave = [];
        var allconditionsfilled = true;
       
        for(var i=0;i<conditions.length;i++){
            var object = {};
            var currentconditionstoSave = {};

            if(conditions[i].condition == ">"){
                object = { lowerBound: conditions[i].setpoint1, upperBound: Infinity, lowerCondition: ">", upperCondition: "" };
            }else if(conditions[i].condition == ">="){
                object = { lowerBound: conditions[i].setpoint1, upperBound: Infinity, lowerCondition: ">=", upperCondition: "" };
            }else if(conditions[i].condition == "<"){
                object = { lowerBound: -Infinity, upperBound: conditions[i].setpoint1, lowerCondition: "", upperCondition: "<" };
            }else if(conditions[i].condition == "<="){
                object = { lowerBound: -Infinity, upperBound: conditions[i].setpoint1, lowerCondition: "", upperCondition: "<=" };
            }else if(conditions[i].condition == "="){
                object = { lowerBound: conditions[i].setpoint1, upperBound: conditions[i].setpoint1, lowerCondition: ">=", upperCondition: "<=" };
            }else if(conditions[i].condition == ">...<"){
                object = { lowerBound: conditions[i].setpoint1, upperBound: conditions[i].setpoint2, lowerCondition: ">", upperCondition: "<" };
            }else if(conditions[i].condition == ">=...<="){
                object = { lowerBound: conditions[i].setpoint1, upperBound: conditions[i].setpoint2, lowerCondition: ">=", upperCondition: "<=" };
            }else if(conditions[i].condition == "<...>"){
                object = { lowerBound: conditions[i].setpoint2, upperBound: conditions[i].setpoint1, lowerCondition: ">", upperCondition: "<" };
            }else if(conditions[i].condition == "<=...>="){
                object = { lowerBound: conditions[i].setpoint2, upperBound: conditions[i].setpoint1, lowerCondition: ">=", upperCondition: "<=" };
            }

            currentconditionstoSave = {
                setpoint1: conditions[i].setpoint1,
                setpoint2: conditions[i].setpoint2,
                condition: conditions[i].condition,
                alarmpriority: conditions[i].alarmpriority,
                normalmessage: conditions[i].normalmessage,
                abnormalmessage: conditions[i].abnormalmessage,
                type:conditions[i].type,
                value: {
                    alarm_condition_lower: (object.lowerBound == -Infinity) ? "-INF" : object.lowerBound,
                    alarm_condition_upper: (object.upperBound == Infinity) ? "INF" : object.upperBound
                }
            }

            if((conditions[i].condition == "")||(conditions[i].type == '')||(conditions[i].setpoint1 == '')||(conditions[i].alarmpriority == '')||((conditions[i].type == 'Ranges') && (conditions[i].setpoint2 == ''))){
                allconditionsfilled=false;
                setboolAllConditionsfilled(false);
            }

            currentConditions.push(object);
            conditionstoSave.push(currentconditionstoSave);
        }
        var objecttosave = {};

        var validationobject = validateConditions(conditionstoSave);
        if(alarmrulename == ''){
            setAlarmRulefilled(false);
        }else{
            setAlarmRulefilled(true);
        }

        if(selectedTag.tagname == ''){
            setConfirmAlarmTagset(false);
        }else{
            setConfirmAlarmTagset(true);
        }

        

        var savedalertobjectconditions = [];
        for (var i = 0; i < conditionstoSave.length; i++) {
    const currentCondition = conditionstoSave[i];
    
    if (!currentCondition) {
        console.error(`Invalid condition at index ${i}:`, currentCondition);
        continue; // Skip processing invalid conditions
    }

    var currentalertobject = {
        condition: currentCondition.condition,
        alarmpriority: currentCondition.alarmpriority,
        normalmessage: currentCondition.normalmessage,
        abnormalmessage: currentCondition.abnormalmessage,
        type: currentCondition.type,
        value: {
            alarm_condition_lower: currentCondition?.value?.alarm_condition_lower,
            alarm_condition_upper: currentCondition?.value?.alarm_condition_upper,
        },
    };

    savedalertobjectconditions.push(currentalertobject);
}

        
        for(var y=0;y<savedalertobjectconditions.length;y++){
            if((!isValidLength(savedalertobjectconditions[y].normalmessage,5,30)) || (!isValidLength(savedalertobjectconditions[y].abnormalmessage,5,30))){
                setopenAlertRuleMessages(true)
                return;
            }

            if(savedalertobjectconditions[y].value.alarm_condition_lower != 'INF'  && savedalertobjectconditions[y].value.alarm_condition_lower != '-INF'){
                if(!isValidNumber(savedalertobjectconditions[y].value.alarm_condition_lower,-36500,36500)){
                    setopenAlertRuleSetpointandMessages(true)
                    return;
                }
            }

            if(savedalertobjectconditions[y].value.alarm_condition_upper != 'INF'  && savedalertobjectconditions[y].value.alarm_condition_upper != '-INF'){
                if(!isValidNumber(savedalertobjectconditions[y].value.alarm_condition_upper,-36500,36500)){
                    setopenAlertRuleSetpointandMessages(true)
                    return;
                }
            }

            
            
        }

        if((configurationValidation.datavalidation == true) && (configurationValidation.rangevalidation==true) && (alarmrulename!=='') && (allconditionsfilled!==false) && (selectedTag.tagname !== '') && (!existingDeviceTagAlarmConfig)){
            var objecttosave = {
                Alert_rule_name: alarmrulename ,
                TagID:selectedTag.tagid,
                DeviceID:tagdetailsobject[selectedTag.tagid]?.DeviceID || 'DeviceID',
                enableAlert: enableAlert,
                SendMessage:sendMessage,
                SendEmail:sendEmail,
                ProjectID:selectedTag.projectid,
                conditions:savedalertobjectconditions,
               // createdAt: new Date().toISOString(),
               // updatedAt: new Date().toISOString(),
            }

            //console.log("objecttosave SAVE handleSaveChange-",objecttosave);

            if((!isValidLength(objecttosave.Alert_rule_name,5,30)) || (containsSpacesOrSpecialChars(objecttosave.Alert_rule_name))){
                setopenAlertRuleNameExceedsLength(true)
                return;
            }

            //console.log("while saving to the database objecttosave",objecttosave)
            setObjecttosavealarmrule(objecttosave)
            //  postalarmconfig(objecttosave,postalarmconfigcallback);
            
            //console.log("currentConditions in handleSaveChange",currentConditions);
            const conflictingConditions = findConflictingGroups(currentConditions);
            //console.log("conflictingConditions in handleSaveChange",conflictingConditions)
            setConflictingConditionsGroups(conflictingConditions);
            setOpen(true);
        }else{

        }
       // props.setAlarmRules(false);
    }

    const postNotificationcallback = (res) => {
        //console.log("postNotificationcallback", res);
        if (!res.success) {
            // Show error message to user, log, etc.
            console.error("Notification config failed:", res.message || res.error);
            // Optionally display a user-facing error
            return;
        }
        // Success: update UI, show success message, etc.
        //console.log("Notification config stored:", res.data);
    };

    function generateCustomUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    function handleSaveConditions(){
        if(Object.keys(objecttosavealarmrule).length !== 0){
            
            postalarmconfig(objecttosavealarmrule,userdetails.Userid,userdetails.Projectid,postalarmconfigcallback);
            postNotification({ id:generateCustomUUID(),TagID:selectedTag.tagid, NotificationGroups:checkedNodes, highest:enablehighestprioritynotification, high:enablehighprioritynotification, medium:enablemediumprioritynotification, low:enablelowprioritynotification}, postNotificationcallback);
            setOpen(false);
        }
        
    }

    function handleConfirmationAlarmUpdatedandSaved(){
        
        setopenAlarmUpdatedandSaved(false)
        props.setAlarmRules(false)
    }

    function handleCloseAlarmUpdatedandSaved(){
        setopenAlarmUpdatedandSaved(false);
        
        props.setAlarmRules(false)
    }

    // Handle user confirmation to delete conflicting conditionsrangesequal
    // const handleDeleteConflicts = () => {
    //     const currentConditionsvar = conditions.map((condition, i) => condition);
        
    //     const filteredConditions = currentConditionsvar.filter((_, index) => {
    //         return !conflictingconditions.some(conflict => conflict.index === index);
    //     });
        
    //     setConditions(filteredConditions);  // Update table with non-conflicting conditions
    //     setOpenDialog(false);  // Close dialog
    //     var objecttosave = {
    //         alarm_rule_name: alarmrulename ,
    //         device_name:selectedAsset.asset_name,
    //         device_id:selectedAsset.device_id,
    //         selected_tag_name: {
    //             tagname: selectedTag.tagname,
    //             tagunit: selectedTag.tagunit,
    //             tagdatatype: selectedTag.tagdatatype,
    //             std_tagname: selectedTag.std_tagname
    //         },
    //         conditions:acceptconditions,
    //         createdAt: new Date().toISOString(),
    //         updatedAt: new Date().toISOString(),
    //     }
    //     postalarmconfig(objecttosave,postalarmconfigcallback);
    //     alert('Conflicting conditions removed and saved successfully.');
    // };


    function linearSearch(arr, target) {
        for (let i = 0; i < arr.length; i++) {
            // Check if the current element in the array matches the target
            if (arr[i] === target) {
                // If found, return the index where the target is located
                return i;
            }
        }
        // If the loop completes without finding the target, return -1 to indicate it's not in the array
        return -1;
    }

    function handleAlarmRuleName(event){
        setAlarmRuleName(event.target.value)
    }

    function handleSelectedOption(){

    }

    // function handleCloneClick(alarm_rule){
    //     console.log("handleCloneClick, alarm_rule")
    //     setAlarmRuleName(alarm_rule.alarm_rule_name);
    //     setSelectedAsset({asset_name:alarm_rule.device_name, device_id:alarm_rule.device_id})
    //     setSelectedTag({ tagname: alarm_rule.selected_tag_name.tagname, tagunit: alarm_rule.selected_tag_name.tagunit, std_tagname: alarm_rule.selected_tag_name.std_tagname, tagdatatype:alarm_rule.selected_tag_name.tagdatatype})
    //     if(alarm_rule.type_of_config == 'Conditional Alarms'){
    //         setConditions(alarm_rule.conditions);
    //     }else if(alarm_rule.type_of_config == 'Equal Alarms'){
    //         setConditionsEqual(alarm_rule.conditions);
    //     }else if(alarm_rule.type_of_config == 'Ranges Alarms'){
    //         setConditionsRanges(alarm_rule.conditions);
    //     }
    //     //const [selectedTag, setSelectedTag] = useState({ tagname: '', tagunit: '', std_tagname: '', tagdatatype:''});
    //     //const [selectedAsset, setSelectedAsset] = useState({asset_name:'', device_id:''});
    // }

    function handlePriorityCheck(event, priority){
        if(priority == "Highest"){
            setenablehighestprioritynotification((prevstate) => !prevstate)
        }else if(priority == "High"){
            setenablehighprioritynotification((prevstate) => !prevstate)
        }else if(priority == "Medium"){
            setenablemediumprioritynotification((prevstate) => !prevstate)
        }else if(priority == "Low"){
            setenablelowprioritynotification((prevstate) => !prevstate)
        }  
    }

    function handleAlertEnable(event){
        setenableAlert(event.target.checked)
    }

    function handleSendMessage(event){
        setsendMessage(event.target.checked)
    }

    function handleSendEmail(event){
        setsendEmail(event.target.checked)
    }

    function isValidLength(value, minLength, maxLength){
        return value.length >= minLength && value.length <= maxLength;
    }

    function isValidNumber(value, minNumber, maxNumber){
        return Number(value) >= Number(minNumber) && Number(value) <= Number(maxNumber);
    }

    function containsSpacesOrSpecialChars(str) {
        return /[\s\W]/.test(str);
    }

    return(
        <div style={{width:'100%'}}>  
                <div style={{display:"flex", marginTop:0, paddingTop:0}}>
                    <div>
                    </div>
                    {/*(props.alarmrulesclone.state == true) && <Chip label="Click to Clone Alert Rule" sx={{marginTop:'10px',marginLeft:"370px"}} onClick={() => handleCloneClick(props.alarmrulesclone.alarm_value)} />*/}
                    <div style={{flexGrow: 1}}></div>
                    {((existingDeviceTagAlarmConfig==true) && <Typography sx={{marginRight:"20px",marginTop:"5px",fontSize:"16px",fontFamily:"Roboto",color:'#DC272D',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginLeft:"10px",marginTop:"10px"}}>Existing Alarm Rule created for this device and tag</Typography>)}
                    {((alarmrulefilled==false) && <Typography sx={{marginRight:"20px",marginTop:"5px",fontSize:"16px",fontFamily:"Roboto",color:'#DC272D',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginLeft:"10px",marginTop:"10px"}}>Please enter alarm rule name</Typography>)}
                    {((configurationValidation.datavalidation == false) && <Typography sx={{marginRight:"20px",marginTop:"5px",fontSize:"16px",fontFamily:"Roboto",color:'#DC272D',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginLeft:"10px",marginTop:"10px"}}>Please complete all fields</Typography>)}
                    {((configurationValidation.rangevalidation == false) && <Typography sx={{marginRight:"20px",marginTop:"5px",fontSize:"16px",fontFamily:"Roboto",color:'#DC272D',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginLeft:"10px",marginTop:"10px"}}>Please enter data setpoint within range limit of tag data type</Typography>)}
                    {((confirmAlarmTagset==false)  && <Typography sx={{marginRight:"20px",marginTop:"5px",fontSize:"16px",fontFamily:"Roboto",color:'#DC272D',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginLeft:"10px",marginTop:"10px"}}>Select Tag from Device</Typography>)}
                    <div style={{marginTop:"10px",marginRight:"5px"}}><CustomCancelButton sx={{}} margin='10px 15px 0px 0px' onClick={handleCancelChange} buttonText={'Cancel'}></CustomCancelButton></div>
                    <Button sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'100px',fontSize: '16px',textTransform:'capitalize', marginTop:"10px", marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" onClick={handleSaveChange}>Save</Button>
                </div>
                
                <div style={{display:"flex", flexDirection:"row"}}>
                    <div style={{width:"20%"}}>
                        <div>
                            <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",marginTop:"6px", textAlign:"left"}}>Enter Rule Name<span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span></Typography>
                            <Box style={{ textAlign: "left", paddingTop: "0px" }}>
                                <TextField required className="textfield" 
                                            sx={{width: '300px', marginLeft:"16px",marginTop:"0px",fontSize:"16px",fontFamily:"Roboto",marginLeft:"14px",
                                                            '& .MuiInputBase-input:focus': {
                                                                color: '#008CD7',
                                                            },
                                                            '& .MuiInputBase-root': {
                                                                fontFamily: 'Roboto',
                                                                fontSize: '16px',
                                                                fontWeight: '700',
                                                                color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                            },
                                                            '& .MuiInput-root .MuiInputBase-input': {
                                                                
                                                            },
                                                            '& .MuiInputBase-root::before': {
                                                                borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                                                            },
                                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                                borderBottom: '2px solid #008CD7',
                                                            },
                                                            '& .MuiInputBase-root::after': {
                                                                borderBottom: '2px solid #008CD7',
                                            
                                                            },
                                    }} label="" value={alarmrulename} variant="standard" 
                                    onChange={handleAlarmRuleName}
                                    inputProps={{ minLength:5, maxLength: 30, }}
                                    helperText={(alarmrulename.length>0 && (!isValidLength(alarmrulename,5,30) || containsSpacesOrSpecialChars(alarmrulename))) ? `Length must be between 5 and 30 with no special characters and whitespaces allowed. ${alarmrulename.length}/30 characters used` : `${alarmrulename.length}/30 characters used`}
                                    FormHelperTextProps={{
                                    sx : { color: !isValidLength(alarmrulename,5,30) ? '#DC272D' : '#00943D',
                                            maxWidth: '300px',
                                            minHeight: '65px',
                                    }
                                    }}
                                />
                            </Box>
                        </div>
                        <div>
                            <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"10px",marginBottom:"10px"}}>Selected Tagname:{selectedAsset.asset_name+": "+selectedTag.tagname + "    "+selectedTag.tagunit}<span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span></Typography>
                            <div>
                                <AssetTagsRetrieval assetdata={assetdata} assetdataerror={assetdataerror} setExistingDeviceTagAlarmConfig={setExistingDeviceTagAlarmConfig} setSelectedTag={setSelectedTag} setSelectedAsset={setSelectedAsset} />
                            </div>
                        </div>
                    </div>
                   
                    <div style={{width:'80%', marginLeft:"25px"}}>
                         <div>
                            {/* Table for entering conditions */}
                            { ((selectedTag.tagdatatype !== 'bool') &&
                                <>
                                    <div style={{ overflowY: 'auto', padding: '20px' }} >
                                        <TableContainer component={Paper} sx={{width: '100%', paddingLeft:'0px',backgroundColor:'var(--secondary-backgroundLK)',paddingRight:'0px',height:`calc(100vh - ${pagesize}px)-200px`,}} className="styled-scrollbar" elevation={0}>
                                            <Table stickyHeader  sx={{ width: '100%', }} size="large"  >
                                            <TableHead  sx={{ width: '100%'}}>
                                                <TableRow sx={{border:"0px"}}>
                                                    <TableCell align="left" sx={{ backgroundColor:'var(--secondary-backgroundLK)',padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><div style={{display:'flex', flexDirection:'row', alignItems:'center'}}><CustomTableHeading children={'Type'}/><span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span></div></TableCell>
                                                    <TableCell align="left" sx={{ backgroundColor:'var(--secondary-backgroundLK)',padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><div style={{display:'flex', flexDirection:'row', alignItems:'center'}}><CustomTableHeading children={'Condition'}/><span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span></div></TableCell>
                                                    <TableCell align="left" sx={{ backgroundColor:'var(--secondary-backgroundLK)',padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><div style={{display:'flex', flexDirection:'row', alignItems:'center'}}><CustomTableHeading children={'Setpoint1'}/><span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span></div></TableCell>
                                                    <TableCell align="left" sx={{ backgroundColor:'var(--secondary-backgroundLK)',padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><div style={{display:'flex', flexDirection:'row', alignItems:'center'}}><CustomTableHeading children={'Setpoint2'}/><span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span></div></TableCell>
                                                    <TableCell align="left" sx={{ backgroundColor:'var(--secondary-backgroundLK)',padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><div style={{display:'flex', flexDirection:'row', alignItems:'center'}}><CustomTableHeading children={'Alert Priority'}/><span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span></div></TableCell>
                                                    <TableCell align="left" sx={{ backgroundColor:'var(--secondary-backgroundLK)',padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><CustomTableHeading children={'Abnormal Message'}/></TableCell>
                                                    <TableCell align="left" sx={{ backgroundColor:'var(--secondary-backgroundLK)',padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><CustomTableHeading children={'Normal Message'}/></TableCell>
                                                    <TableCell align="left" sx={{ backgroundColor:'var(--secondary-backgroundLK)',padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><CustomTableHeading children={'Delete'}/></TableCell>
                                                    <TableCell align="left" sx={{ backgroundColor:'var(--secondary-backgroundLK)',padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><CustomTableHeading children={'Add'}/></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {conditions.map((condition, index) => (
                                                <TableRow key={index} sx={{'&:last-child td, &:last-child th': { border: 0 },height:"9px",'& > *': { borderBottom: "1px solid var(--table-boarder-line)" } }}>
                                                    <TableCell component="th" scope="row" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                        <FormControl variant="standard" sx={{ marginTop:"0px", minWidth: 50 }}>
                                                            <Select
                                                                labelId="demo-simple-select-standard-label"
                                                                id="demo-simple-select-standard"
                                                                IconComponent={KeyboardArrowDownIcon}
                                                                sx={{
                                                                    "&:before": {
                                                                    borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`  
                                                                    },
                                                                    "&:hover:not(.Mui-disabled):before": {
                                                                        borderBottom: '2px solid #008CD7',
                                                                    },
                                                                    "&:after": {
                                                                        borderBottom: '2px solid #008CD7',
                                                                    },
                                                                    margin: 0,
                                                                    padding: 0,
                                                                    width: '100px',
                                                                    fontSize: "18px",
                                                                    fontFamily: "Roboto",
                                                                    fontWeight: '700 !important',
                                                                    color: 'var(--PrimaryText)',
                                                                    '& .MuiInputBase-input': {
                                                                        paddingLeft: 0
                                                                    },
                                                                    '& .MuiInputBase-input:focus': {
                                                                        color: 'var(--HighlightedText_Stroke)',
                                                                        borderBottom: '2px solid var(--HighlightedText_Stroke)',
                                                                        backgroundColor: 'transparent',
                                                                        fontWeight: '700 !important',
                                                                        '& .MuiSvgIcon-root': {
                                                                            color: 'var(--HighlightedText_Stroke) !important'
                                                                        },
                                                                    },
                                                                    '& .MuiInputBase-input:focus .MuiSvgIcon-root': {
                                                                        color: 'var(--HighlightedText_Stroke)',       //not working
                                                                    },
                                                                    '& .MuiSvgIcon-root': {
                                                                        color: 'var(--PrimaryText)'
                                                                    },
                                                                    '& .MuiNativeSelect-select': {
                                                                        paddingTop: 0,
                                                                        paddingBottom: 0,
                                                                    },
                                                                    '& .MuiNativeSelect-select option': {
                                                                        backgroundColor: 'var(--dropdown-bg) !important',
                                                                        fontSize: "18px",
                                                                        fontFamily: "Roboto",
                                                                        fontWeight: 400,
                                                                        color: 'var(--PrimaryText) !important',
                                                                        borderBottom: '2px solid var(--HighlightedText_Stroke)',  //not working
                                                                    },
                                                                    '& .MuiNativeSelect-select option:checked': {
                                                                        backgroundColor: 'var(--dropdown-bg) !important',
                                                                        color: 'var(--White) !important',
                                                                        fontWeight: '700 !important',
                                                                        borderColor: '2px solid var(--HighlightedText_Stroke)'
                                                                    },
                                                                    '& .MuiInputBase-input option:hover': {
                                                                        backgroundColor: '#005D8F !important',
                                                                    },
                                                    
                                                                }}
                                                                MenuProps={{
                                                                    PaperProps:{
                                                                        sx:{
                                                                            width:"100px",
                                                                            bgcolor:themechange==='dark'?'#3C3C3C':'#C1C1C1',
                                                                            borderBottom:'2px solid #008CD7',
                                                                            borderRadius:0,
                                                                            boxShadow:'none',
                                                                            maxHeight:'250px',
                                                                            overflow:'auto',
                                                                            color:themechange==='dark'?'#FFFFFF':'#3C3C3C',
                                                                        }
                                                                    },               
                                                                }}
                                                                label=""
                                                                value={condition.type}
                                                                disabled={(existingDeviceTagAlarmConfig==true || (selectedTag.tagname=='' && selectedTag.tagunit==''))}
                                                                onChange={(e) =>  handleConditionChange(index, 'type', e.target.value)}
                                                            >
                                                                <MenuItem sx={{paddingLeft:1}} value={"Conditional"}>{"Conditional"}</MenuItem>
                                                                <MenuItem sx={{paddingLeft:1}} value={"Equal"}>{"Equal"}</MenuItem>
                                                                <MenuItem sx={{paddingLeft:1}}value={"Ranges"}>{"Ranges"}</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                        <FormControl variant="standard" sx={{ marginTop:"0px", minWidth: 50 }}>
                                                            <Select
                                                                labelId="demo-simple-select-standard-label"
                                                                id="demo-simple-select-standard"
                                                                IconComponent={KeyboardArrowDownIcon}
                                                                sx={{
                                                                    "&:before": {
                                                                    borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`  
                                                                    },
                                                                    "&:hover:not(.Mui-disabled):before": {
                                                                        borderBottom: '2px solid #008CD7',
                                                                    },
                                                                    "&:after": {
                                                                        borderBottom: '2px solid #008CD7',
                                                                    },
                                                                    margin: 0,
                                                                    padding: 0,
                                                                    width: '100px',
                                                                    fontSize: "18px",
                                                                    fontFamily: "Roboto",
                                                                    fontWeight: '700 !important',
                                                                    color: 'var(--PrimaryText)',
                                                                    '& .MuiInputBase-input': {
                                                                        paddingLeft: 0
                                                                    },
                                                                    '& .MuiInputBase-input:focus': {
                                                                        color: 'var(--HighlightedText_Stroke)',
                                                                        borderBottom: '2px solid var(--HighlightedText_Stroke)',
                                                                        backgroundColor: 'transparent',
                                                                        fontWeight: '700 !important',
                                                                        '& .MuiSvgIcon-root': {
                                                                            color: 'var(--HighlightedText_Stroke) !important'
                                                                        },
                                                                    },
                                                                    '& .MuiInputBase-input:focus .MuiSvgIcon-root': {
                                                                        color: 'var(--HighlightedText_Stroke)',       //not working
                                                                    },
                                                                    '& .MuiSvgIcon-root': {
                                                                        color: 'var(--PrimaryText)'
                                                                    },
                                                                    '& .MuiNativeSelect-select': {
                                                                        paddingTop: 0,
                                                                        paddingBottom: 0,
                                                                    },
                                                                    '& .MuiNativeSelect-select option': {
                                                                        backgroundColor: 'var(--dropdown-bg) !important',
                                                                        fontSize: "18px",
                                                                        fontFamily: "Roboto",
                                                                        fontWeight: 400,
                                                                        color: 'var(--PrimaryText) !important',
                                                                        borderBottom: '2px solid var(--HighlightedText_Stroke)',  //not working
                                                                    },
                                                                    '& .MuiNativeSelect-select option:checked': {
                                                                        backgroundColor: 'var(--dropdown-bg) !important',
                                                                        color: 'var(--White) !important',
                                                                        fontWeight: '700 !important',
                                                                        borderColor: '2px solid var(--HighlightedText_Stroke)'
                                                                    },
                                                                    '& .MuiInputBase-input option:hover': {
                                                                        backgroundColor: '#005D8F !important',
                                                                    },
                                                    
                                                                }}
                                                                MenuProps={{
                                                                    PaperProps:{
                                                                        sx:{
                                                                            width:"100px",
                                                                            bgcolor:themechange==='dark'?'#3C3C3C':'#C1C1C1',
                                                                            borderBottom:'2px solid #008CD7',
                                                                            borderRadius:0,
                                                                            boxShadow:'none',
                                                                            maxHeight:'250px',
                                                                            overflow:'auto',
                                                                            color:themechange==='dark'?'#FFFFFF':'#3C3C3C',
                                                                        }
                                                                    },               
                                                                }}
                                                                label=""
                                                                value={condition.condition}
                                                                disabled={(existingDeviceTagAlarmConfig==true ||( selectedTag.tagname=='' && selectedTag.tagunit==''))}
                                                                onChange={(e) =>  handleConditionChange(index, 'condition', e.target.value)}
                                                            >
                                                                {(condition.type == "Conditional") && <MenuItem sx={{paddingLeft:1}} value={"<="}>{"<="}</MenuItem>}
                                                                {/* <MenuItem sx={{paddingLeft:1}} value={"="}>{"="}</MenuItem> */}
                                                                {(condition.type == "Conditional") && <MenuItem sx={{paddingLeft:1}}value={">="}>{">="}</MenuItem>}
                                                                {(condition.type == "Conditional") && <MenuItem sx={{paddingLeft:1}} value={"<"}>{"<"}</MenuItem>}
                                                                {(condition.type == "Conditional") && <MenuItem sx={{paddingLeft:1}}value={">"}>{">"}</MenuItem>}
                                                                {(condition.type == "Equal") && <MenuItem sx={{paddingLeft:1}}value={"="}>{"="}</MenuItem>}
                                                                {(condition.type == "Ranges") && <MenuItem sx={{paddingLeft:1}}value={">...<"}>{">...<"}</MenuItem>}
                                                                {(condition.type == "Ranges") && <MenuItem sx={{paddingLeft:1}}value={">=...<="}>{">=...<="}</MenuItem>}
                                                                {(condition.type == "Ranges") && <MenuItem sx={{paddingLeft:1}}value={"<...>"}>{"<...>"}</MenuItem>}
                                                                {(condition.type == "Ranges") && <MenuItem sx={{paddingLeft:1}}value={"<=...>="}>{"<=...>="}</MenuItem>}
                                                            </Select>
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                        {/* <Box className="config-form-box" >
                                                            <Typography  style={{ fontSize: '18px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Gateway Name</Typography>
                                                            <CustomTextField id={'negative-feedback'} selected={handleGatewayName} defaultValue={gatewayno[props.index].data.GatewayName} width={224}/> 
                                                        </Box>*/} 
                                                        <TextField
                                                            label=""
                                                            value={condition.setpoint1}
                                                            variant="standard"
                                                            type="number"
                                                            disabled={existingDeviceTagAlarmConfig==true}
                                                            onChange={(e) =>
                                                                handleConditionChange(index, 'setpoint1', e.target.value)
                                                            }
                                                            sx={{
                                                                width: '94px',
                                                                '& .MuiInputBase-input:focus': {
                                                                    color: '#008CD7',
                                                                },
                                                                '& .MuiInputBase-root': {
                                                                    fontFamily: 'Roboto',
                                                                    fontSize: '16px',
                                                                    fontWeight: '700',
                                                                    color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                                },
                                                                '& .MuiInput-root .MuiInputBase-input': {
                                                                    
                                                                },
                                                                '& .MuiInputBase-root::before': {
                                                                    borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                                                                },
                                                                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                                    borderBottom: '2px solid #008CD7',
                                                                },
                                                                '& .MuiInputBase-root::after': {
                                                                    borderBottom: '2px solid #008CD7',
                                                
                                                                },
                                                            }}
                                                            inputProps={{ min:5, max: 30, }}
                                                            helperText={(!isValidNumber(condition.setpoint1,-36500,36500)) ? `Number must be between -36500 and 36500` : ``}
                                                            FormHelperTextProps={{
                                                            sx : { color: !isValidNumber(condition.setpoint1,-36500,36500) ? '#DC272D' : '#00943D' }
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                        {/* <Box className="config-form-box" >
                                                            <Typography  style={{ fontSize: '18px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Gateway Name</Typography>
                                                            <CustomTextField id={'negative-feedback'} selected={handleGatewayName} defaultValue={gatewayno[props.index].data.GatewayName} width={224}/> 
                                                        </Box>*/} 
                                                        <TextField
                                                            label=""
                                                            value={condition.setpoint2}
                                                            variant="standard"
                                                            type="number"
                                                            onChange={(e) =>
                                                                handleConditionChange(index, 'setpoint2', e.target.value)
                                                            }
                                                            disabled={(existingDeviceTagAlarmConfig==true || condition.type != "Ranges")}
                                                            sx={{
                                                                width: '94px',
                                                                '& .MuiInputBase-input:focus': {
                                                                    color: '#008CD7',
                                                                },
                                                                '& .MuiInputBase-root': {
                                                                    fontFamily: 'Roboto',
                                                                    fontSize: '16px',
                                                                    fontWeight: '700',
                                                                    color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                                },
                                                                '& .MuiInput-root .MuiInputBase-input': {
                                                                    
                                                                },
                                                                '& .MuiInputBase-root::before': {
                                                                    borderBottom: (condition.type == "Ranges") ? `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}` : `1px dotted ${'#7E7E7E'}`
                                                                },
                                                                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                                    borderBottom: '2px solid #008CD7',
                                                                },
                                                                '& .MuiInputBase-root::after': {
                                                                    borderBottom: '2px solid #008CD7',
                                                
                                                                },
                                                            }}
                                                            inputProps={{ min:5, max: 30, }}
                                                            helperText={(!isValidNumber(condition.setpoint2,-36500,36500)) ? `Number must be between -36500 and 36500` : ``}
                                                            FormHelperTextProps={{
                                                            sx : { color: !isValidNumber(condition.setpoint2,-36500,36500) ? '#DC272D' : '#00943D' }
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                        <FormControl variant="standard" sx={{ marginTop:"0px", minWidth: 120 }}>
                                                            <Select
                                                            labelId="demo-simple-select-standard-label"
                                                            id="demo-simple-select-standard"
                                                            IconComponent={KeyboardArrowDownIcon}
                                                            sx={{
                                                                "&:before": {
                                                                borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`  
                                                                },
                                                                "&:hover:not(.Mui-disabled):before": {
                                                                    borderBottom: '2px solid #008CD7',
                                                                },
                                                                "&:after": {
                                                                    borderBottom: '2px solid #008CD7',
                                                                },
                                                                margin: 0,
                                                                padding: 0,
                                                                width: '193px',
                                                                fontSize: "18px",
                                                                fontFamily: "Roboto",
                                                                fontWeight: '700 !important',
                                                                color: 'var(--PrimaryText)',
                                                                '& .MuiInputBase-input': {
                                                                    paddingLeft: 0
                                                                },
                                                                '& .MuiInputBase-input:focus': {
                                                                    color: 'var(--HighlightedText_Stroke)',
                                                                    borderBottom: '2px solid var(--HighlightedText_Stroke)',
                                                                    backgroundColor: 'transparent',
                                                                    fontWeight: '700 !important',
                                                                    '& .MuiSvgIcon-root': {
                                                                        color: 'var(--HighlightedText_Stroke) !important'
                                                                    },
                                                                },
                                                                '& .MuiInputBase-input:focus .MuiSvgIcon-root': {
                                                                    color: 'var(--HighlightedText_Stroke)',       //not working
                                                                },
                                                                '& .MuiSvgIcon-root': {
                                                                    color: 'var(--PrimaryText)'
                                                                },
                                                                '& .MuiNativeSelect-select': {
                                                                    paddingTop: 0,
                                                                    paddingBottom: 0,
                                                                },
                                                                '& .MuiNativeSelect-select option': {
                                                                    backgroundColor: 'var(--dropdown-bg) !important',
                                                                    fontSize: "18px",
                                                                    fontFamily: "Roboto",
                                                                    fontWeight: 400,
                                                                    color: 'var(--PrimaryText) !important',
                                                                    borderBottom: '2px solid var(--HighlightedText_Stroke)',  //not working
                                                                },
                                                                '& .MuiNativeSelect-select option:checked': {
                                                                    backgroundColor: 'var(--dropdown-bg) !important',
                                                                    color: 'var(--White) !important',
                                                                    fontWeight: '700 !important',
                                                                    borderColor: '2px solid var(--HighlightedText_Stroke)'
                                                                },
                                                                '& .MuiInputBase-input option:hover': {
                                                                    backgroundColor: '#005D8F !important',
                                                                },
                                                
                                                            }}
                                                            MenuProps={{
                                                                PaperProps:{
                                                                    sx:{
                                                                        width:"40px",
                                                                        bgcolor:themechange==='dark'?'#3C3C3C':'#C1C1C1',
                                                                        borderBottom:'2px solid #008CD7',
                                                                        borderRadius:0,
                                                                        boxShadow:'none',
                                                                        maxHeight:'250px',
                                                                        overflow:'auto',
                                                                        color:themechange==='dark'?'#FFFFFF':'#3C3C3C',
                                                                    }
                                                                },               
                                                            }}
                                                            disabled={existingDeviceTagAlarmConfig==true}
                                                            onChange={(e) =>  handleConditionChange(index, 'alarmpriority', e.target.value)}
                                                            label="Alarm Priority"
                                                            value={condition.alarmpriority}
                                                            >
                                                            <MenuItem value={"Highest"}>{"Highest"}</MenuItem>
                                                            <MenuItem value={"High"}>{"High"}</MenuItem>
                                                            <MenuItem value={"Medium"}>{"Medium"}</MenuItem>
                                                            <MenuItem value={"Low"}>{"Low"}</MenuItem>
                                                        
                                                            </Select>
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                        <TextField
                                                            label=""
                                                            value={condition.abnormalmessage}
                                                            variant='standard'
                                                            disabled={existingDeviceTagAlarmConfig==true}
                                                            sx={{
                                                                width: '94px',
                                                                '& .MuiInputBase-input:focus': {
                                                                    color: '#008CD7',
                                                                },
                                                                '& .MuiInputBase-root': {
                                                                    fontFamily: 'Roboto',
                                                                    fontSize: '16px',
                                                                    fontWeight: '700',
                                                                    color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                                },
                                                                '& .MuiInput-root .MuiInputBase-input': {
                                                                    
                                                                },
                                                                '& .MuiInputBase-root::before': {
                                                                    borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                                                                },
                                                                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                                    borderBottom: '2px solid #008CD7',
                                                                },
                                                                '& .MuiInputBase-root::after': {
                                                                    borderBottom: '2px solid #008CD7',
                                                
                                                                },
                                                            }}
                                                            onChange={(e) =>
                                                                handleConditionChange(index, 'abnormalmessage', e.target.value)
                                                            }
                                                            inputProps={{ minLength:5, maxLength: 30, }}
                                                            helperText={(condition.abnormalmessage.length>0 && !isValidLength(condition.abnormalmessage,5,30)) ? `Length must be between 5 and 30. ${condition.abnormalmessage.length}/30 characters used` : `${condition.abnormalmessage.length}/30 characters used`}
                                                            FormHelperTextProps={{
                                                            sx : { color: !isValidLength(condition.abnormalmessage,5,30) ? '#DC272D' : '#00943D' }
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                        <TextField
                                                            label=""
                                                            value={condition.normalmessage}
                                                            variant='standard'
                                                            disabled={existingDeviceTagAlarmConfig==true}
                                                            sx={{
                                                                width: '94px',
                                                                '& .MuiInputBase-input:focus': {
                                                                    color: '#008CD7',
                                                                },
                                                                '& .MuiInputBase-root': {
                                                                    fontFamily: 'Roboto',
                                                                    fontSize: '16px',
                                                                    fontWeight: '700',
                                                                    color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                                },
                                                                '& .MuiInput-root .MuiInputBase-input': {
                                                                    
                                                                },
                                                                '& .MuiInputBase-root::before': {
                                                                    borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                                                                },
                                                                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                                    borderBottom: '2px solid #008CD7',
                                                                },
                                                                '& .MuiInputBase-root::after': {
                                                                    borderBottom: '2px solid #008CD7',
                                                
                                                                },
                                                            }}
                                                            onChange={(e) =>
                                                                handleConditionChange(index, 'normalmessage', e.target.value)
                                                            }
                                                            inputProps={{ minLength:5, maxLength: 30, }}
                                                            helperText={(condition.normalmessage.length>0 && !isValidLength(condition.normalmessage,5,30)) ? `Length must be between 5 and 30. ${condition.normalmessage.length}/30 characters used` : `${condition.normalmessage.length}/30 characters used`}
                                                            FormHelperTextProps={{
                                                            sx : { color: !isValidLength(condition.normalmessage,5,30) ? '#DC272D' : '#00943D' }
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"2px",paddingBottom:"2px"}}>
                                                        <Button sx={{ width:"20px",height:"20px",padding:"0px",fontSize:"16px",fontFamily:"Roboto",textTransform:'capitalize', backgroundColor:"var(--SecondaryBackground)", borderRadius:"20px", boxShadow: "none"}} variant="text" onClick={() => handleRemoveRow(index)} disableTouchRipple elevation={0}><LK_Delete color={"#005C8E"} width={"20px"} height={"20px"}/></Button>
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" sx={{ alignItems:"baseline",padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"2px",paddingBottom:"2px"}}>
                                                        {<div style={{display:"flex", marginTop:0, paddingTop:0}}>
                                                            <CustomActionButton buttonText={'Add Row'} onClick={handleAddRow} />
                                                         </div>}
                                                    </TableCell>
                                                </TableRow>
                                                ))}
                                            </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                    {/* Provision to remove overlapping conditions */}
                                    {/*<Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                                        <DialogTitle>Overlapping Conditions Detected</DialogTitle>
                                        <DialogContent>
                                            {conflictingconditions.map((conflict, index) => (
                                                <Typography key={index}>
                                                    Conflict for Condition {conflict.condition} with setpoint {conflict.setpoint1}
                                                </Typography>
                                            ))}
                                            <Typography>Do you want to remove these conflicting conditions?</Typography>
                                        </DialogContent>
                                        <DialogActions>
                                        <Button onClick={handleDeleteConflicts} color="primary">
                                            Yes, Delete Conflicts
                                        </Button>
                                        <Button onClick={() => setOpenDialog(false)} color="secondary">
                                            No, I'll Edit Manually
                                        </Button>
                                        </DialogActions>
                                    </Dialog>
                                    */}

                                </>
                            )}
                            { ((selectedTag.tagdatatype === 'bool') &&
                                <>
                                    <div style={{ overflowY: 'auto', padding: '20px' }} >
                                        <TableContainer component={Paper} sx={{width: '100%', paddingLeft:'0px',backgroundColor:'var(--secondary-backgroundLK)',paddingRight:'0px',height:`calc(100vh - ${pagesize}px)-200px`,}} className="styled-scrollbar" elevation={0}>
                                            <Table stickyHeader  sx={{ width: '100%', }} size="large"  >
                                            <TableHead  sx={{ width: '100%'}}>
                                                <TableRow sx={{border:"0px"}}>
                                                    <TableCell align="left" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><div style={{display:'flex', flexDirection:'row', alignItems:'center'}}><CustomTableHeading children={'Type'}/><span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span></div></TableCell>
                                                    <TableCell align="left" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><div style={{display:'flex', flexDirection:'row', alignItems:'center'}}><CustomTableHeading children={'Condition'}/><span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span></div></TableCell>
                                                    <TableCell align="left" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><div style={{display:'flex', flexDirection:'row', alignItems:'center'}}><CustomTableHeading children={'Setpoint1'}/><span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span></div></TableCell>
                                                    <TableCell align="left" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><div style={{display:'flex', flexDirection:'row', alignItems:'center'}}><CustomTableHeading children={'Setpoint2'}/><span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span></div></TableCell>
                                                    <TableCell align="left" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><div style={{display:'flex', flexDirection:'row', alignItems:'center'}}><CustomTableHeading children={'Alarm Priority'}/><span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span></div></TableCell>
                                                    <TableCell align="left" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><CustomTableHeading children={'Abnormal Message'}/></TableCell>
                                                    <TableCell align="left" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><CustomTableHeading children={'Normal Message'}/></TableCell>
                                                    <TableCell align="left" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><CustomTableHeading children={'Delete'}/></TableCell>
                                                    <TableCell align="left" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><CustomTableHeading children={'Add'}/></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {conditions.map((condition, index) => (
                                                <TableRow key={index} sx={{'&:last-child td, &:last-child th': { border: 0 },height:"9px",'& > *': { borderBottom: "1px solid var(--table-boarder-line)" } }}>
                                                    <TableCell component="th" scope="row" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                        <FormControl variant="standard" sx={{ marginTop:"0px", minWidth: 50 }}>
                                                            <Select
                                                                labelId="demo-simple-select-standard-label"
                                                                id="demo-simple-select-standard"
                                                                IconComponent={KeyboardArrowDownIcon}
                                                                sx={{
                                                                    "&:before": {
                                                                    borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`  
                                                                    },
                                                                    "&:hover:not(.Mui-disabled):before": {
                                                                        borderBottom: '2px solid #008CD7',
                                                                    },
                                                                    "&:after": {
                                                                        borderBottom: '2px solid #008CD7',
                                                                    },
                                                                    margin: 0,
                                                                    padding: 0,
                                                                    width: '100px',
                                                                    fontSize: "18px",
                                                                    fontFamily: "Roboto",
                                                                    fontWeight: '700 !important',
                                                                    color: 'var(--PrimaryText)',
                                                                    '& .MuiInputBase-input': {
                                                                        paddingLeft: 0
                                                                    },
                                                                    '& .MuiInputBase-input:focus': {
                                                                        color: 'var(--HighlightedText_Stroke)',
                                                                        borderBottom: '2px solid var(--HighlightedText_Stroke)',
                                                                        backgroundColor: 'transparent',
                                                                        fontWeight: '700 !important',
                                                                        '& .MuiSvgIcon-root': {
                                                                            color: 'var(--HighlightedText_Stroke) !important'
                                                                        },
                                                                    },
                                                                    '& .MuiInputBase-input:focus .MuiSvgIcon-root': {
                                                                        color: 'var(--HighlightedText_Stroke)',       //not working
                                                                    },
                                                                    '& .MuiSvgIcon-root': {
                                                                        color: 'var(--PrimaryText)'
                                                                    },
                                                                    '& .MuiNativeSelect-select': {
                                                                        paddingTop: 0,
                                                                        paddingBottom: 0,
                                                                    },
                                                                    '& .MuiNativeSelect-select option': {
                                                                        backgroundColor: 'var(--dropdown-bg) !important',
                                                                        fontSize: "18px",
                                                                        fontFamily: "Roboto",
                                                                        fontWeight: 400,
                                                                        color: 'var(--PrimaryText) !important',
                                                                        borderBottom: '2px solid var(--HighlightedText_Stroke)',  //not working
                                                                    },
                                                                    '& .MuiNativeSelect-select option:checked': {
                                                                        backgroundColor: 'var(--dropdown-bg) !important',
                                                                        color: 'var(--White) !important',
                                                                        fontWeight: '700 !important',
                                                                        borderColor: '2px solid var(--HighlightedText_Stroke)'
                                                                    },
                                                                    '& .MuiInputBase-input option:hover': {
                                                                        backgroundColor: '#005D8F !important',
                                                                    },
                                                    
                                                                }}
                                                                MenuProps={{
                                                                    PaperProps:{
                                                                        sx:{
                                                                            width:"100px",
                                                                            bgcolor:themechange==='dark'?'#3C3C3C':'#C1C1C1',
                                                                            borderBottom:'2px solid #008CD7',
                                                                            borderRadius:0,
                                                                            boxShadow:'none',
                                                                            maxHeight:'250px',
                                                                            overflow:'auto',
                                                                            color:themechange==='dark'?'#FFFFFF':'#3C3C3C',
                                                                        }
                                                                    },               
                                                                }}
                                                                label=""
                                                                value={condition.type}
                                                                disabled={(existingDeviceTagAlarmConfig==true || (selectedTag.tagname=='' && selectedTag.tagunit==''))}
                                                                onChange={(e) =>  handleConditionChange(index, 'type', e.target.value)}
                                                            >
                                                                <MenuItem sx={{paddingLeft:1}} value={"True"}>{"True"}</MenuItem>
                                                                <MenuItem sx={{paddingLeft:1}} value={"False"}>{"False"}</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                        <FormControl variant="standard" sx={{ marginTop:"0px", minWidth: 50 }}>
                                                            <Select
                                                                labelId="demo-simple-select-standard-label"
                                                                id="demo-simple-select-standard"
                                                                IconComponent={KeyboardArrowDownIcon}
                                                                sx={{
                                                                    "&:before": {
                                                                    borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`  
                                                                    },
                                                                    "&:hover:not(.Mui-disabled):before": {
                                                                        borderBottom: '2px solid #008CD7',
                                                                    },
                                                                    "&:after": {
                                                                        borderBottom: '2px solid #008CD7',
                                                                    },
                                                                    margin: 0,
                                                                    padding: 0,
                                                                    width: '100px',
                                                                    fontSize: "18px",
                                                                    fontFamily: "Roboto",
                                                                    fontWeight: '700 !important',
                                                                    color: 'var(--PrimaryText)',
                                                                    '& .MuiInputBase-input': {
                                                                        paddingLeft: 0
                                                                    },
                                                                    '& .MuiInputBase-input:focus': {
                                                                        color: 'var(--HighlightedText_Stroke)',
                                                                        borderBottom: '2px solid var(--HighlightedText_Stroke)',
                                                                        backgroundColor: 'transparent',
                                                                        fontWeight: '700 !important',
                                                                        '& .MuiSvgIcon-root': {
                                                                            color: 'var(--HighlightedText_Stroke) !important'
                                                                        },
                                                                    },
                                                                    '& .MuiInputBase-input:focus .MuiSvgIcon-root': {
                                                                        color: 'var(--HighlightedText_Stroke)',       //not working
                                                                    },
                                                                    '& .MuiSvgIcon-root': {
                                                                        color: 'var(--PrimaryText)'
                                                                    },
                                                                    '& .MuiNativeSelect-select': {
                                                                        paddingTop: 0,
                                                                        paddingBottom: 0,
                                                                    },
                                                                    '& .MuiNativeSelect-select option': {
                                                                        backgroundColor: 'var(--dropdown-bg) !important',
                                                                        fontSize: "18px",
                                                                        fontFamily: "Roboto",
                                                                        fontWeight: 400,
                                                                        color: 'var(--PrimaryText) !important',
                                                                        borderBottom: '2px solid var(--HighlightedText_Stroke)',  //not working
                                                                    },
                                                                    '& .MuiNativeSelect-select option:checked': {
                                                                        backgroundColor: 'var(--dropdown-bg) !important',
                                                                        color: 'var(--White) !important',
                                                                        fontWeight: '700 !important',
                                                                        borderColor: '2px solid var(--HighlightedText_Stroke)'
                                                                    },
                                                                    '& .MuiInputBase-input option:hover': {
                                                                        backgroundColor: '#005D8F !important',
                                                                    },
                                                    
                                                                }}
                                                                MenuProps={{
                                                                    PaperProps:{
                                                                        sx:{
                                                                            width:"100px",
                                                                            bgcolor:themechange==='dark'?'#3C3C3C':'#C1C1C1',
                                                                            borderBottom:'2px solid #008CD7',
                                                                            borderRadius:0,
                                                                            boxShadow:'none',
                                                                            maxHeight:'250px',
                                                                            overflow:'auto',
                                                                            color:themechange==='dark'?'#FFFFFF':'#3C3C3C',
                                                                        }
                                                                    },               
                                                                }}
                                                                label=""
                                                                value={condition.condition}
                                                                disabled={existingDeviceTagAlarmConfig==true}
                                                                onChange={(e) =>  handleConditionChange(index, 'condition', e.target.value)}
                                                            >
                                                                {(condition.type == "True") && <MenuItem sx={{paddingLeft:1}} value={"="}>{"="}</MenuItem>}
                                                                {(condition.type == "False") && <MenuItem sx={{paddingLeft:1}}value={"="}>{"="}</MenuItem>}
                                                            
                                                            </Select>
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                        {/* <Box className="config-form-box" >
                                                            <Typography  style={{ fontSize: '18px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Gateway Name</Typography>
                                                            <CustomTextField id={'negative-feedback'} selected={handleGatewayName} defaultValue={gatewayno[props.index].data.GatewayName} width={224}/> 
                                                        </Box>*/} 
                                                        <TextField
                                                            label=""
                                                            value={condition.setpoint1}
                                                            variant="standard"
                                                            type="number"
                                                            disabled={existingDeviceTagAlarmConfig==true}
                                                            onChange={(e) =>
                                                                handleConditionChange(index, 'setpoint1', e.target.value)
                                                            }
                                                            sx={{
                                                                width: '94px',
                                                                '& .MuiInputBase-input:focus': {
                                                                    color: '#008CD7',
                                                                },
                                                                '& .MuiInputBase-root': {
                                                                    fontFamily: 'Roboto',
                                                                    fontSize: '16px',
                                                                    fontWeight: '700',
                                                                    color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                                },
                                                                '& .MuiInput-root .MuiInputBase-input': {
                                                                    
                                                                },
                                                                '& .MuiInputBase-root::before': {
                                                                    borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                                                                },
                                                                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                                    borderBottom: '2px solid #008CD7',
                                                                },
                                                                '& .MuiInputBase-root::after': {
                                                                    borderBottom: '2px solid #008CD7',
                                                
                                                                },
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                        {/* <Box className="config-form-box" >
                                                            <Typography  style={{ fontSize: '18px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Gateway Name</Typography>
                                                            <CustomTextField id={'negative-feedback'} selected={handleGatewayName} defaultValue={gatewayno[props.index].data.GatewayName} width={224}/> 
                                                        </Box>*/} 
                                                        <TextField
                                                            label=""
                                                            value={condition.setpoint2}
                                                            variant="standard"
                                                            type="number"
                                                            onChange={(e) =>
                                                                handleConditionChange(index, 'setpoint2', e.target.value)
                                                            }
                                                            disabled={existingDeviceTagAlarmConfig==true}
                                                            sx={{
                                                                width: '94px',
                                                                '& .MuiInputBase-input:focus': {
                                                                    color: '#008CD7',
                                                                },
                                                                '& .MuiInputBase-root': {
                                                                    fontFamily: 'Roboto',
                                                                    fontSize: '16px',
                                                                    fontWeight: '700',
                                                                    color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                                },
                                                                '& .MuiInput-root .MuiInputBase-input': {
                                                                    
                                                                },
                                                                '& .MuiInputBase-root::before': {
                                                                    borderBottom: (condition.type == "Ranges") ? `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}` : `1px dotted ${'#7E7E7E'}`
                                                                },
                                                                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                                    borderBottom: '2px solid #008CD7',
                                                                },
                                                                '& .MuiInputBase-root::after': {
                                                                    borderBottom: '2px solid #008CD7',
                                                
                                                                },
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                        <FormControl variant="standard" sx={{ marginTop:"0px", minWidth: 120 }}>
                                                            <Select
                                                            labelId="demo-simple-select-standard-label"
                                                            id="demo-simple-select-standard"
                                                            IconComponent={KeyboardArrowDownIcon}
                                                            sx={{
                                                                "&:before": {
                                                                borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`  
                                                                },
                                                                "&:hover:not(.Mui-disabled):before": {
                                                                    borderBottom: '2px solid #008CD7',
                                                                },
                                                                "&:after": {
                                                                    borderBottom: '2px solid #008CD7',
                                                                },
                                                                margin: 0,
                                                                padding: 0,
                                                                width: '193px',
                                                                fontSize: "18px",
                                                                fontFamily: "Roboto",
                                                                fontWeight: '700 !important',
                                                                color: 'var(--PrimaryText)',
                                                                '& .MuiInputBase-input': {
                                                                    paddingLeft: 0
                                                                },
                                                                '& .MuiInputBase-input:focus': {
                                                                    color: 'var(--HighlightedText_Stroke)',
                                                                    borderBottom: '2px solid var(--HighlightedText_Stroke)',
                                                                    backgroundColor: 'transparent',
                                                                    fontWeight: '700 !important',
                                                                    '& .MuiSvgIcon-root': {
                                                                        color: 'var(--HighlightedText_Stroke) !important'
                                                                    },
                                                                },
                                                                '& .MuiInputBase-input:focus .MuiSvgIcon-root': {
                                                                    color: 'var(--HighlightedText_Stroke)',       //not working
                                                                },
                                                                '& .MuiSvgIcon-root': {
                                                                    color: 'var(--PrimaryText)'
                                                                },
                                                                '& .MuiNativeSelect-select': {
                                                                    paddingTop: 0,
                                                                    paddingBottom: 0,
                                                                },
                                                                '& .MuiNativeSelect-select option': {
                                                                    backgroundColor: 'var(--dropdown-bg) !important',
                                                                    fontSize: "18px",
                                                                    fontFamily: "Roboto",
                                                                    fontWeight: 400,
                                                                    color: 'var(--PrimaryText) !important',
                                                                    borderBottom: '2px solid var(--HighlightedText_Stroke)',  //not working
                                                                },
                                                                '& .MuiNativeSelect-select option:checked': {
                                                                    backgroundColor: 'var(--dropdown-bg) !important',
                                                                    color: 'var(--White) !important',
                                                                    fontWeight: '700 !important',
                                                                    borderColor: '2px solid var(--HighlightedText_Stroke)'
                                                                },
                                                                '& .MuiInputBase-input option:hover': {
                                                                    backgroundColor: '#005D8F !important',
                                                                },
                                                
                                                            }}
                                                            MenuProps={{
                                                                PaperProps:{
                                                                    sx:{
                                                                        width:"40px",
                                                                        bgcolor:themechange==='dark'?'#3C3C3C':'#C1C1C1',
                                                                        borderBottom:'2px solid #008CD7',
                                                                        borderRadius:0,
                                                                        boxShadow:'none',
                                                                        maxHeight:'250px',
                                                                        overflow:'auto',
                                                                        color:themechange==='dark'?'#FFFFFF':'#3C3C3C',
                                                                    }
                                                                },               
                                                            }}
                                                            onChange={(e) =>  handleConditionChange(index, 'alarmpriority', e.target.value)}
                                                            label="Alarm Priority"
                                                            disabled={existingDeviceTagAlarmConfig==true}
                                                            value={condition.alarmpriority}
                                                            >
                                                            <MenuItem value={"Highest"}>{"Highest"}</MenuItem>
                                                            <MenuItem value={"High"}>{"High"}</MenuItem>
                                                            <MenuItem value={"Medium"}>{"Medium"}</MenuItem>
                                                            <MenuItem value={"Low"}>{"Low"}</MenuItem>
                                                        
                                                            </Select>
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                        <TextField
                                                            label=""
                                                            value={condition.abnormalmessage}
                                                            variant='standard'
                                                            disabled={existingDeviceTagAlarmConfig==true}
                                                            sx={{
                                                                width: '94px',
                                                                '& .MuiInputBase-input:focus': {
                                                                    color: '#008CD7',
                                                                },
                                                                '& .MuiInputBase-root': {
                                                                    fontFamily: 'Roboto',
                                                                    fontSize: '16px',
                                                                    fontWeight: '700',
                                                                    color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                                },
                                                                '& .MuiInput-root .MuiInputBase-input': {
                                                                    
                                                                },
                                                                '& .MuiInputBase-root::before': {
                                                                    borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                                                                },
                                                                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                                    borderBottom: '2px solid #008CD7',
                                                                },
                                                                '& .MuiInputBase-root::after': {
                                                                    borderBottom: '2px solid #008CD7',
                                                
                                                                },
                                                            }}
                                                            onChange={(e) =>
                                                                handleConditionChange(index, 'abnormalmessage', e.target.value)
                                                            }
                                                        />
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                        <TextField
                                                            label=""
                                                            value={condition.normalmessage}
                                                            variant='standard'
                                                            disabled={existingDeviceTagAlarmConfig==true}
                                                            sx={{
                                                                width: '94px',
                                                                '& .MuiInputBase-input:focus': {
                                                                    color: '#008CD7',
                                                                },
                                                                '& .MuiInputBase-root': {
                                                                    fontFamily: 'Roboto',
                                                                    fontSize: '16px',
                                                                    fontWeight: '700',
                                                                },
                                                                '& .MuiInput-root .MuiInputBase-input': {
                                                                    
                                                                },
                                                                '& .MuiInputBase-root::before': {
                                                                    borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                                                                },
                                                                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                                    borderBottom: '2px solid #008CD7',
                                                                },
                                                                '& .MuiInputBase-root::after': {
                                                                    borderBottom: '2px solid #008CD7',
                                                
                                                                },
                                                            }}
                                                            onChange={(e) =>
                                                                handleConditionChange(index, 'normalmessage', e.target.value)
                                                            }
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                ))}
                                            </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                    {/* Provision to remove overlapping conditions */}
                                    {/*<Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                                        <DialogTitle>Overlapping Conditions Detected</DialogTitle>
                                        <DialogContent>
                                            {conflictingconditions.map((conflict, index) => (
                                                <Typography key={index}>
                                                    Conflict for Condition {conflict.condition} with setpoint {conflict.setpoint1}
                                                </Typography>
                                            ))}
                                            <Typography>Do you want to remove these conflicting conditions?</Typography>
                                        </DialogContent>
                                        <DialogActions>
                                        <Button onClick={handleDeleteConflicts} color="primary">
                                            Yes, Delete Conflicts
                                        </Button>
                                        <Button onClick={() => setOpenDialog(false)} color="secondary">
                                            No, I'll Edit Manually
                                        </Button>
                                        </DialogActions>
                                    </Dialog>*/}

                                </>
                            )}
                            <Dialog 
                                open={open} 
                                onClose={handleClose}
                                BackdropProps={{
                                    sx:{
                                        backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                                    }
                                }}
                                sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}>
                                <DialogTitle sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>{"Confirm Save Action"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                    <h5>Note: In Overlapping Conditions Groups higher priority alarm will be raised.In case of equal priorities sequentially first entered condition will be considered</h5>    
                                    {conflictingConditionsGroups.map((group, index) => (
                                                <div key={index}>
                                                <h5>Group {index + 1}:</h5>
                                                <ul>
                                                    {group.map((condition, i) => (
                                                    <li key={i}>
                                                        {condition.lowerCondition} {condition.lowerBound === -Infinity ? "-Infinity" : condition.lowerBound} to {condition.upperBound === Infinity ? "Infinity" : condition.upperBound} {condition.upperCondition}
                                                    </li>
                                                    ))}
                                                </ul>
                                                </div>
                                    ))}
                                        Are you sure you want to save the changes?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions sx={{justifyContent:'center'}}>
                                    <Button onClick={handleSaveConditions} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                                        Confirm
                                    </Button>
                                    <CustomCancelButton onClick={handleClose} buttonText={'Cancel'}></CustomCancelButton>
                                </DialogActions>
                            </Dialog>

                            <Dialog
                                open={openAtLeastOneConditionDialog}
                                onClose={handleCloseAtLeastOneConditionDialog}
                                BackdropProps={{
                                    sx:{
                                        backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                                    }
                                }}
                                sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}
                            >
                                <DialogTitle  sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>Single Condition</DialogTitle>
                                    <DialogContent >
                                        <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                            At least one condition is required
                                        </DialogContentText>
                                    </DialogContent>
                                <DialogActions sx={{justifyContent:'center'}}> 
                                    <Button onClick={handleConfirmationAtLeastOneConditionDialog} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                                        Ok
                                    </Button>
                                    <CustomCancelButton width={"125px"} onClick={handleCloseAtLeastOneConditionDialog} buttonText={'Cancel'}></CustomCancelButton>
                                </DialogActions>
                            </Dialog>

                            <Dialog
                                open={openMaxConditionDialog}
                                onClose={handleCloseMaxConditionDialog}
                                BackdropProps={{
                                    sx:{
                                        backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                                    }
                                }}
                                sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}
                            >
                                <DialogTitle  sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>Maximum Conditions</DialogTitle>
                                    <DialogContent >
                                        <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                            We can enter maximum 10 conditions
                                        </DialogContentText>
                                    </DialogContent>
                                <DialogActions sx={{justifyContent:'center'}}> 
                                    <Button onClick={handleConfirmationMaxConditionDialog} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                                        Ok
                                    </Button>
                                    <CustomCancelButton width={"125px"} onClick={handleCloseMaxConditionDialog} buttonText={'Cancel'}></CustomCancelButton>
                                </DialogActions>
                            </Dialog>

                            {/*<Dialog
                                open={openAlarmUpdatedandSaved}
                                onClose={handleCloseAlarmUpdatedandSaved}
                                BackdropProps={{
                                    sx:{
                                        backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                                    }
                                }}
                                sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}
                            >
                                <DialogTitle  sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>Single Condition</DialogTitle>
                                    <DialogContent >
                                        <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                            
                                        </DialogContentText>
                                    </DialogContent>
                                <DialogActions sx={{justifyContent:'center'}}> 
                                    <Button onClick={handleConfirmationAlarmUpdatedandSaved} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                                        Ok
                                    </Button>
                                    <CustomCancelButton width={"125px"} onClick={handleCloseAlarmUpdatedandSaved} buttonText={'Cancel'}></CustomCancelButton>
                                </DialogActions>
                            </Dialog>*/}

                            <CustomDialogBox
                                    dialogTitle={"Alert Rule Creation"}
                                    dialogText={"Successfully created Alert Rule"}
                                    openDialog={openAlarmUpdatedandSaved}
                                    handleCloseDialog={handleCloseAlarmUpdatedandSaved}
                                    handleConfirmDialog={handleConfirmationAlarmUpdatedandSaved}
                                    confirmText={"Ok"}
                                    cancelText={"Cancel"}
                                    type={"Success"}
                                  />

                            <Dialog
                                open={alertruleNotSaved}
                                onClose={handleaslertRuleNotSaved}
                                BackdropProps={{
                                    sx:{
                                        backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                                    }
                                }}
                                sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}
                            >
                                <DialogTitle  sx={{color:"#FFFFFF", backgroundColor:"#dc272d",margin:"5px", borderRadius:"100px", }}>Alert Rule Not Saved</DialogTitle>
                                    <DialogContent >
                                        <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                            Could not Save Alert Rule. Try Again!
                                        </DialogContentText>
                                    </DialogContent>
                                <DialogActions sx={{justifyContent:'center'}}> 
                                    <Button onClick={handleaslertRuleNotSaved} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                                        Ok
                                    </Button>
                                    <CustomCancelButton width={"125px"} onClick={handleaslertRuleNotSaved} buttonText={'Cancel'}></CustomCancelButton>
                                </DialogActions>
                            </Dialog> 

                            <CustomDialogBox
                                    dialogTitle={"Alert Rule Not Saved"}
                                    dialogText={openDuplicateAlarmMsg}
                                    openDialog={openDuplicateAlarm}
                                    handleCloseDialog={handleCloseDuplicateAlarm}
                                    handleConfirmDialog={handleConfirmationDuplicateAlarm}
                                    confirmText={"Ok"}
                                    cancelText={"Cancel"}
                                    type={"Error"}
                                  />

                            {/* <Dialog
                                open={openDuplicateAlarm}
                                onClose={handleCloseDuplicateAlarm}
                                BackdropProps={{
                                    sx:{
                                        backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                                    }
                                }}
                                sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}
                            >
                                <DialogTitle  sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>Single Condition</DialogTitle>
                                    <DialogContent >
                                        <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                            {openDuplicateAlarmMsg? openDuplicateAlarmMsg : "Duplicate entry - Try again"}
                                        </DialogContentText>
                                    </DialogContent>
                                <DialogActions sx={{justifyContent:'center'}}> 
                                    <Button onClick={handleConfirmationDuplicateAlarm} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                                        Ok
                                    </Button>
                                    <CustomCancelButton width={"125px"} onClick={handleCloseDuplicateAlarm} buttonText={'Cancel'}></CustomCancelButton>
                                </DialogActions>
                            </Dialog> */}

                            <Dialog
                                open={openAlertRuleNameExceedsLength}
                                onClose={handleAlertRuleNameExceedsLength}
                                BackdropProps={{
                                    sx:{
                                        backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                                    }
                                }}
                                sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}
                            >
                                <DialogTitle  sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>Single Condition</DialogTitle>
                                    <DialogContent >
                                        <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                            Check if Alert Rule Name has length between 5-30 characters and no special characters
                                        </DialogContentText>
                                    </DialogContent>
                                <DialogActions sx={{justifyContent:'center'}}> 
                                    <Button onClick={handleAlertRuleNameExceedsLength} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                                        Ok
                                    </Button>
                                    <CustomCancelButton width={"125px"} onClick={handleAlertRuleNameExceedsLength} buttonText={'Cancel'}></CustomCancelButton>
                                </DialogActions>
                            </Dialog>

                            <Dialog
                                open={openAlertRuleSetpointandMessages}
                                onClose={handleAlertRuleSetpointandMessages}
                                BackdropProps={{
                                    sx:{
                                        backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                                    }
                                }}
                                sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}
                            >
                                <DialogTitle  sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>Single Condition</DialogTitle>
                                    <DialogContent >
                                        <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                            Check if any of setpoints have values less than -36500 or greater than 36500 
                                        </DialogContentText>
                                    </DialogContent>
                                <DialogActions sx={{justifyContent:'center'}}> 
                                    <Button onClick={handleAlertRuleSetpointandMessages} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                                        Ok
                                    </Button>
                                    <CustomCancelButton width={"125px"} onClick={handleAlertRuleSetpointandMessages} buttonText={'Cancel'}></CustomCancelButton>
                                </DialogActions>
                            </Dialog>

                            <Dialog
                                open={openAlertRuleMessages}
                                onClose={handleAlertRuleMessages}
                                BackdropProps={{
                                    sx:{
                                        backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                                    }
                                }}
                                sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}
                            >
                                <DialogTitle  sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>Invalid Alert Rule Name</DialogTitle>
                                    <DialogContent >
                                        <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                        Check if messages have length between 5-30 characters with no special characters
                                        </DialogContentText>
                                    </DialogContent>
                                <DialogActions sx={{justifyContent:'center'}}> 
                                    <Button onClick={handleAlertRuleMessages} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                                        Ok
                                    </Button>
                                    <CustomCancelButton width={"125px"} onClick={handleAlertRuleMessages} buttonText={'Cancel'}></CustomCancelButton>
                                </DialogActions>
                            </Dialog>

                        </div>
                        
                        <div style={{marginLeft:"25px", alignItems:"end"}}>
                            <Typography sx={{marginRight:"20px",fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400,  marginLeft:"0px",textAlign:"left"}}>Select User Group to send Notification</Typography>
                            <Box style={{ border: "1px solid #008CD7", display: 'flex', flexDirection: 'column', height: "347px", width:"90%", padding: '0px 16px', overflowY: "scroll" }}>
                                { (userGroupsError == true) && <Typography sx={{marginRight:"20px",fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400,  marginLeft:"0px",textAlign:"left"}}>User Groups not Found</Typography>}
                                { (userGroupsError == false) && 
                                        
                                            ((userGroups != null) && (userGroups != undefined))
                                            ?
                                            ((userGroups.length>0)?
                                            userGroups.map((objecttreeview, index) => {
                                            if(objecttreeview.hasOwnProperty("ProjectID")){
                                                
                                                return (
                                                    <div style={{ display: "block" }} key={index}>
                                                        <SimpleTreeView sx={{color:'var(--SecondaryText)','& .MuiTreeItem-label .MuiTreeItem-content':{
                                                                    fontSize:'16px',
                                                                    fontWeight:400,
                                                                    color:"red",
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden'
                                                                },}} defaultCollapseIcon="-" defaultExpandIcon="+">
                                                                <TreeItem itemId={objecttreeview["id"]} label={
                                                                    
                                                                    <Typography sx={{ display: 'flex', alignItems: 'left',whiteSpace: "nowrap",overflow: "hidden",textOverflow: "ellipsis" }}>
                                                                    <Checkbox 
                                                                            checkedIcon={<CheckBoxOutlinedIcon />} 
                                                                            style={{ color: "var(--SecondaryText)" }}
                                                                            checked={checkedNodes.some(checkedNode => checkedNode.id === objecttreeview["id"])}
                                                                            sx={{
                                                                                padding: 0,
                                                                                margin: 0,
                                                                                color: 'var(--HighlightedText_Stroke)',
                                                                                '& .MuiSvgIcon-root': {
                                                                                    fontSize: '20px',
                                                                                    color: 'var(--HighlightedText_Stroke)'
                                                                                }
                                                                            }}
                                                                            onChange={(event) => handleCheck(event, objecttreeview, objecttreeview["id"], objecttreeview["groupName"], objecttreeview["id"])}
                                                                        />

                                                                    <span style={{color:'var(--SecondaryText)'}}>{objecttreeview["groupName"]}</span>
                                                                </Typography>
                                                                
                                                                }                                                                                    
                                                                    sx={{'& .MuiTreeItem-label':{
                                                                    fontSize:'16px',
                                                                    fontWeight:400,
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden'
                                                                },}}>
                                                                {objecttreeview["users"].map((currentGroup, index) =>
                                                                    renderTreeNodes(currentGroup, checkedNode,objecttreeview["groupName"],objecttreeview["id"])
                                                                )}
                                                            </TreeItem>
                                                        </SimpleTreeView>
                                                    </div>
                                                );
                                            }else{
                                                <></>;
                                            }
                                            }):<></>)
                                            :<></>
                                        
                                }
                            </Box>
                        </div>
                        <div style={{marginLeft:"25px",}}>
                            <div style={{display:"flex", flexDirection:"row",}}>
                                <Typography sx={{fontSize:"16px",color:'var(--SecondaryText)',marginRight:"30px"}}>{"Enable Notification as per Priority"}</Typography>
                                <Checkbox 
                                    checkedIcon={<CheckBoxOutlinedIcon />} 
                                    style={{ color: "var(--SecondaryText)" }}
                                    checked={enablehighestprioritynotification}
                                    sx={{
                                        padding: 0,
                                        margin: 0,
                                        color: 'var(--HighlightedText_Stroke)',
                                        '& .MuiSvgIcon-root': {
                                            fontSize: '20px',
                                            color: 'var(--HighlightedText_Stroke)'
                                        }
                                    }}
                                    onChange={(event) => handlePriorityCheck(event, "Highest")}
                                />

                                <Typography sx={{fontSize:"16px",color:'var(--SecondaryText)',marginRight:"30px",marginRight:"30px"}}>{"Highest"}</Typography> 
                                
                                <Checkbox 
                                    checkedIcon={<CheckBoxOutlinedIcon />} 
                                    style={{ color: "var(--SecondaryText)" }}
                                    checked={enablehighprioritynotification}
                                    sx={{
                                        padding: 0,
                                        margin: 0,
                                        color: 'var(--HighlightedText_Stroke)',
                                        '& .MuiSvgIcon-root': {
                                            fontSize: '20px',
                                            color: 'var(--HighlightedText_Stroke)'
                                        }
                                    }}
                                    onChange={(event) => handlePriorityCheck(event, "High")}
                                />

                                <Typography sx={{fontSize:"16px",color:'var(--SecondaryText)',marginRight:"30px"}}>{"High"}</Typography>   
                                <Checkbox 
                                    checkedIcon={<CheckBoxOutlinedIcon />} 
                                    style={{ color: "var(--SecondaryText)" }}
                                    checked={enablemediumprioritynotification}
                                    sx={{
                                        padding: 0,
                                        margin: 0,
                                        color: 'var(--HighlightedText_Stroke)',
                                        '& .MuiSvgIcon-root': {
                                            fontSize: '20px',
                                            color: 'var(--HighlightedText_Stroke)'
                                        }
                                    }}
                                    onChange={(event) => handlePriorityCheck(event, "Medium")}
                                />

                                <Typography sx={{fontSize:"16px",color:'var(--SecondaryText)',marginRight:"30px"}}>{"Medium"}</Typography> 
                                <Checkbox 
                                    checkedIcon={<CheckBoxOutlinedIcon />} 
                                    style={{ color: "var(--SecondaryText)" }}
                                    checked={enablelowprioritynotification}
                                    sx={{
                                        padding: 0,
                                        margin: 0,
                                        color: 'var(--HighlightedText_Stroke)',
                                        '& .MuiSvgIcon-root': {
                                            fontSize: '20px',
                                            color: 'var(--HighlightedText_Stroke)'
                                        }
                                    }}
                                    onChange={(event) => handlePriorityCheck(event, "Low")}
                                />
                                <Typography sx={{fontSize:"16px",color:'var(--SecondaryText)',marginRight:"30px"}}>{"Low"}</Typography>     
                                <div style={{flexGrow:1}}></div>
                                <Checkbox 
                                    checkedIcon={<CheckBoxOutlinedIcon />} 
                                    style={{ color: "var(--SecondaryText)" }}
                                    checked={enableAlert}
                                    sx={{
                                        padding: 0,
                                        margin: 0,
                                        color: 'var(--HighlightedText_Stroke)',
                                        '& .MuiSvgIcon-root': {
                                            fontSize: '20px',
                                            color: 'var(--HighlightedText_Stroke)'
                                        }
                                    }}
                                    onChange={(event) => handleAlertEnable(event)}
                                />
                                <Typography sx={{fontSize:"16px",color:'var(--SecondaryText)',marginRight:"10px"}}>{"Enable Alert Rule"}</Typography>  
                                
                                                            
                                    <Checkbox 
                                        checkedIcon={<CheckBoxOutlinedIcon />} 
                                        style={{ color: "var(--SecondaryText)" }}
                                        checked={sendMessage}
                                        sx={{
                                            padding: 0,
                                            margin: 0,
                                            color: 'var(--HighlightedText_Stroke)',
                                            '& .MuiSvgIcon-root': {
                                                fontSize: '20px',
                                                color: 'var(--HighlightedText_Stroke)'
                                            }
                                        }}
                                        onChange={(event) => handleSendMessage(event)}
                                    />
                                    
                                <Typography sx={{fontSize:"16px",color:'var(--SecondaryText)',marginRight:"10px"}}>{"Enable Message"}</Typography>                    
                                
                            
                                    <Checkbox 
                                        checkedIcon={<CheckBoxOutlinedIcon />} 
                                        style={{ color: "var(--SecondaryText)" }}
                                        checked={sendEmail}
                                        sx={{
                                            padding: 0,
                                            margin: 0,
                                            color: 'var(--HighlightedText_Stroke)',
                                            '& .MuiSvgIcon-root': {
                                                fontSize: '20px',
                                                color: 'var(--HighlightedText_Stroke)'
                                            }
                                        }}
                                        onChange={(event) => handleSendEmail(event)}
                                    />
                                    
                                <Typography sx={{fontSize:"16px",color:'var(--SecondaryText)',marginRight:"95px"}}>{"Enable Email"}</Typography>          
                                                
                            </div>
                            <div style={{display:"flex", flexDirection:"row",}}>
                                <Typography sx={{fontSize:"12px",color:'var(--SecondaryText)',marginRight:"30px"}}>{"Note: Maximum 10 conditions allowed"}</Typography>
                            </div>
                            
                        </div>
                    </div>
                </div>
                
        </div>
    )
}